<template>
  <form-wizard ref="edit_fms_vehicles_form" color="#39C0ED" @on-complete="editBizdevVehicle">
    <h2 slot="title"></h2>

    <tab-content
      title="Registration"
      :before-change="() => validateStep('childVehicleComponent')"
    >
      <vehicle-card
          :fms_vehicle.sync="fms_vehicle"
        ref="childVehicleComponent"
      />
    </tab-content>
    <tab-content title="Document" :before-change="() => validateStep('childDocumentComponent')">
      <document-card
         :fms_vehicle="fms_vehicle"
        ref="childDocumentComponent"
      />
    </tab-content>
    <tab-content title="Accesories info" :before-change="() => validateStep('childAccesoriesComponent')">
      <accesories-card
         :fms_vehicle="fms_vehicle"
        ref="childAccesoriesComponent"
      />
    </tab-content>
  </form-wizard>
</template>


<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// import komponen
import VehicleCard from "@/pages/Dashboard/Fms/Vehicle/ComponentForm/VehicleCard.vue";
import DocumentCard from "@/pages/Dashboard/Fms/Vehicle/ComponentForm/DocumentCard.vue";
import AccesoriesCard from "@/pages/Dashboard/Fms/Vehicle/ComponentForm/AccesoriesCard.vue";
import Swal from "sweetalert2";


export default {
  name: "edit-bizdev-vehicles",



  components: {
    // ValidationError,
    FormWizard,
    TabContent,
    "vehicle-card": VehicleCard,
    "document-card": DocumentCard,
    "accesories-card": AccesoriesCard,
      
  },

  props: {
    data_id: null,
  },

  mixins: [formMixin],

  data: () => ({
      fms_vehicle:[],
    
  }),

  created() {
    this.getBizdevVehicleData();
  },

  methods: {
    //fungsi dipanggile saat page pertamakali dibuka
    async getBizdevVehicleData(){
      //check id ikut terkirim di route
      if(this.data_id.id){

        //ambil data di server sesuai dengan data id yang ada di route
        await this.$store.dispatch("fms_vehicle/get", this.data_id.id)
        this.fms_vehicle = await this.$store.getters["fms_vehicle/fms_vehicle"]

        if(this.fms_vehicle.vehicle_pool){
          this.fms_vehicle.vehicle_pool = this.fms_vehicle.vehicle_pool.id
        }
        console.log(this.fms_vehicle.vehicle_pool)

         //butuh jeda time sebelum mengupdate value di chield client
        var self = this;
        setTimeout(function(){
          self.$refs.childVehicleComponent.getDataParent()
          self.$refs.childDocumentComponent.getDataParent()
          self.$refs.childAccesoriesComponent.getDataParent()

        }, 1);
           
           
          

      }
      else{
        //jika tidak ada kembali ke list
        this.$parent.$parent.modalCloseEdit();
        // await this.$router.replace({name: 'List Vehicle'});
      }
    },

    resetFile(ref) {
      this.$refs[ref].clearField()
    },

    
       sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },

    // fungsi edit data
    async editBizdevVehicle() {
       this.$refs.childVehicleComponent.getData()
      this.$refs.childDocumentComponent.getData()
      this.$refs.childAccesoriesComponent.getData()

      //set var data yang akan dikirm ke server
      const data = {
        type: "fms_vehicles",
        id:this.fms_vehicle.id,
        vehicle_type_id: this.fms_vehicle.vehicle_type_id,
        // vehicle_body_color: this.fms_vehicle.vehicle_body_color,
        vehicle_registration_year: this.fms_vehicle.vehicle_registration_year,
        // vehicle_plate_no: this.fms_vehicle.vehicle_plate_no,
        vehicle_chassis_no: this.fms_vehicle.vehicle_chassis_no,
        vehicle_engine_no: this.fms_vehicle.vehicle_engine_no,
        vehicle_door_no : this.fms_vehicle.vehicle_door_no,
        vehicle_pool : this.fms_vehicle.vehicle_pool,
        vehicle_business_unit_id : this.fms_vehicle.vehicle_business_unit_id,
        vehicle_production_year : this.fms_vehicle.vehicle_production_year,
        vehicle_plate_color : this.fms_vehicle.vehicle_plate_color,
        // vehicle_registration_name : this.fms_vehicle.vehicle_registration_name,
        vehicle_document: this.fms_vehicle.document,
        vehicle_accessory: this.fms_vehicle.accesories,
      }
      
      console.log(data)
      try {
          //kirim data ke server
        await this.$store.dispatch("fms_vehicle/update", data);
             //panggil alert succes
        await this.$store.dispatch(
        "alerts/success",
        "Successfully registered."
        );
        //kembali ke list
        // await this.$router.replace({name: 'Detail Vehicle', params: { id: this.fms_vehicle.id }});
        this.$parent.$parent.modalCloseEdit();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
        "alerts/error",
        "Oops, something went wrong"
        );
        this.setApiValidation(e.response.data.errors);
      }

    },
      
    //   //set data yang diambil dari child info
    // dataInfo (value) {
    //   console.log(value) 
    //   this.fms_vehicle.info = value
      
    // },
    
    // //set data yang diambil dari child client
    // dataClient (value) {
    //   console.log(value) 
    //   this.fms_vehicle.client = value
    // },
      
    //   //set data yang diambil dari child vehicle
    // dataVehicle (value) {
    //   this.fms_vehicle = value
    // },
    
    // //set data yang diambil dari child service
    // dataService (value) {
    //   console.log(value) 
    //   console.log("bahahaha")
    //   this.fms_vehicle.service = value
    // },
    
    // //set data yang diambil dari child part
    // dataPart (value) {
    //   // console.log(value) 
    //   this.fms_vehicle.part = value
    // },
    
    //checke validasi stiap child sebulum pindah section
    validateStep(name) {
      var refToValidate = this.$refs[name]
      return refToValidate.validateForm()
    },
  }
};
</script>
